module.exports = {
      id: "ic-highest-lowest-light-active-usage",
      viewBox: "0 0 160 120",
      url: __webpack_public_path__ + "sprite-ad374a.smartcharts.svg#ic-highest-lowest-light-active-usage",
      toString: function () {
        return this.url;
      }
    }